const CORE_HOST = process.env.REACT_APP_CORE_HOST;
const CALLMAN_KEY = process.env.REACT_APP_CALLMAN_KEY;

export const validateMeeting = async ({ roomId }) => {
  const url = `${CORE_HOST}/api/v1/callman/video-calls/validate-room/${roomId}`;

  const options = {
    method: 'GET',
    headers: {
      Authorization: CALLMAN_KEY,
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error('Error validando room_id', error);
    return null;
  }
};
